module.exports = __webpack_public_path__ + "img/lock.1824c2c3.svg";